<template>
    <section class="section section--gutter no-gutter--top calculator-roaming">
        <div class="spring">
            <div class="js-component-component component__component" data-component="world-traveller-bundle">
                <div class="bundle bundle--horizontal">
                    <div class="bundle__summary">
                        <div class="grid">
                            <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/1 grid__item--1/1">
                                <h2 class="heading heading--3 heading--light heading--leading heading--center">Calculator internet disponibil în roaming</h2>
                            </div>
                            <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/2 grid__item--1/2 border-right-calc grid__item--sm-1/1">
                                <span @click="DECREMENT" class="NumberMinus">&ndash;</span>
                                <input id="calcIn" name="calcIn" v-model.number="initialValue" maxlength="3" type="text" />
                                <span class="calcIn--currency">&euro;</span>
                                <span @click="INCREMENT" class="NumberPlus">+</span>
                                <h3 class="heading heading--5 heading--light heading--leading heading--center">
                                    Valoare în &euro; cu TVA
                                    <br />Abonament + Extraopțiuni Internet
                                </h3>
                            </div>
                            <br class="hide--md hide--lg" />
                            <br class="hide--md hide--lg" />
                            <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/2 grid__item--1/2 grid__item--aligh-right flush--sm-bottom">
                                <p class="color-red heading heading--4 heading--light heading--center no-gutter--all">
                                    <span class="calcResultb calcResultb heading--3">{{ gbtouse }}</span> GB
                                </p>
                                <h3 class="heading heading--5 heading--light heading--leading heading--center color-red">
                                    Internet
                                    <br />disponibil în roaming
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                        <div :class="{ activeMore: toggle_calc_more }" class="js-accordion-content show-more__content show-more__content--collapse" style="display: none">
                            <div class="bundle__inclusions">
                                <ul class="grid--gutter grid">
                                    <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                        <span v-if="initialValue == ''"> Valoarea introdusă trebuie să fie o cifră </span>
                                        <span v-else class="calcResult">
                                            Poți folosi lunar, în țările SEE, până la <strong>{{ gbtouse }} GB trafic de internet din abonamentul tău</strong>, pentru valoarea introdusă de <strong>{{ initialValue }} EUR</strong> (TVA inclus). Dacă abonamentul tău are inclus <strong>mai puțin de {{ gbtouse }} GB</strong>, atunci poți folosi în roaming tot traficul inclus în abonament, iar după consumarea acestuia, în țările SEE, vei fi tarifat la tarifele standard de acasă. Dacă abonamentul tău are inclus <strong>mai mult de {{ gbtouse }} GB</strong> trafic de internet, atunci poţi folosi
                                            gratuit <strong>{{ gbtouse }} GB</strong> trafic de internet din abonament, iar după <strong>{{ gbtouse }} GB</strong>, în ţările SEE, vei fi tarifat astfel: până la consumarea integrală a traficului naţional inclus în abonament se aplică tariful de 0.0023€ (cu TVA)/MB iar după consumarea traficului naţional inclus în abonament se adaugă tariful de 0.018€ (cu TVA)/MB peste tarifele standard de acasă.
                                        </span>

                                        <br />
                                        <br />
                                    </li>
                                    <li class="grid__item grid__item--align-center grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                        Nu dispui de abonament? Activează
                                        <strong>abonamentul de 12€</strong>
                                        <br />
                                    </li>
                                    <li class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/2 grid__item--1/3 grid__item--align-center flush--sm-bottom">
                                        <br />
                                        <a :href="hrefAbonament" @click="triggerLayer" target="_blank" rel="noopener noreferrer" class="button button--primary no-gutter--bottom">Activează</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <button-more @click.native="toggleMore" :more="toggle_calc_more" prefix="Arată mai"></button-more>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ButtonMore from './ButtonMore.vue';

export default {
    name: 'Calculator',
    components: {
        ButtonMore,
    },
    props: {
        countryName: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            toggle_calc_more: true,
            hrefAbonament: this.$root.hrefAbonament,
            initialValue: 10,
            maxlength: 3,
        };
    },
    computed: {
        gbtouse() {
            return ((this.initialValue / 1.844) * 2).toFixed(2);
        },
        page_name() {
            if (this.countryName !== null) {
                return `Roaming ${this.countryName} LP`;
            }
            return 'Homepage Informatii';
        },
    },
    methods: {
        toggleMore() {
            this.toggle_calc_more = !this.toggle_calc_more;
            if (!this.toggle_calc_more) {
                dataLayer.push({
                    event: 'microData',
                    event_name: 'action_click',
                    click_element_name: 'Arata mai putin',
                    page_name: this.page_name,
                });
            }
        },
        triggerLayer() {
            dataLayer.push({
                event: 'microData',
                event_name: 'action_click',
                click_element_name: `Activeaza valoare ${this.initialValue} euro`,
                page_name: this.page_name,
            });
        },
        INCREMENT() {
            let max = Math.pow(10, this.maxlength) - 1;
            if (this.initialValue < max) {
                this.initialValue = parseInt(this.initialValue + 1);
            }
        },
        DECREMENT() {
            if (this.initialValue > 0) {
                this.initialValue = parseInt(this.initialValue - 1);
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            jQuery.fn.ForceNumericOnly = function () {
                return this.each(function () {
                    $(this).keydown(function (e) {
                        var key = e.charCode || e.keyCode || 0;
                        // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
                        // home, end, period, and numpad decimal
                        return key == 8 || key == 9 || key == 13 || key == 46 || key == 110 || key == 190 || (key >= 35 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105);
                    });
                });
            };
            setTimeout(function () {
                $('#calcIn').ForceNumericOnly();
            }, 500);
        });
    },
};
</script>
